import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //src: 'https://localhost:44321',
    //subDirectory: '',
    //src: 'https://gcit.thinker.tw',
    //subDirectory: '/Platform',
    src: 'https://gcit.nccu.edu.tw',
    subDirectory: '/Platform',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
